import { fetchingProduct } from "../helpers/fetchingProduct";
import { productAdded } from "../helpers/productAdded";

if (document.querySelector(".product-data")) {
  const fullProduct = document.querySelector(".product-data"),
    quantity = fullProduct.querySelector(".product-data__qty--number"),
    plus = fullProduct.querySelector(".product-data__qty--button--plus"),
    minus = fullProduct.querySelector(".product-data__qty--button--minus"),
    variations = fullProduct.querySelectorAll(".product-data__vars--variant"),
    addToCart = fullProduct.querySelector(".addToCartButton");

  variations.forEach((variation) => {
    let allVariations = variation.querySelectorAll(".product-data__vars--item");
    allVariations.forEach((singleVar) => singleVar.classList.remove("select"));
    allVariations[0].classList.add("select");

    allVariations.forEach((singleVar) => {
      singleVar.addEventListener("click", () => {
        allVariations.forEach((item) => item.classList.remove("select"));
        singleVar.classList.add("select");
      });
    });
  });

  plus.addEventListener("click", () => {
    quantity.value = parseInt(quantity.value) + 1;
  });
  minus.addEventListener("click", () => {
    quantity.value = Math.max(parseInt(quantity.value) - 1, 0);
  });

  addToCart.addEventListener("click", () => {
    let productId = addToCart.getAttribute("product-id");
    fetchingProduct("/cart/add.js", "POST", "id", productId, quantity.value)
      .then((response) => {
        productAdded(fullProduct);
      })
      .catch((error) => {
        console.error("Error al añadir producto:", error.message);
      });
  });
}
